import type { ClickExpandType } from './blocks';

export const CLICK_EXPAND_MIN_TOPICS = 2;

export const CLICK_EXPAND_MAX_TOPICS: Readonly<Record<ClickExpandType, number>> = {
  accordion: 10,
  'top-tabs': 4,
};

export function getClickExpandMaxTopics(expandType: ClickExpandType): number {
  return CLICK_EXPAND_MAX_TOPICS[expandType];
}

export function canUseTopTabsClickExpandLayout(topicCount: number): boolean {
  return topicCount <= CLICK_EXPAND_MAX_TOPICS['top-tabs'];
}
